/* Fondo 50, borde 200, icono 600, radio 12. Qué pasó y qué hacer. */
.alert {
  --_color: var(--status-info);
  --_fondo: var(--status-info-bg);
  --_borde: var(--status-info-border);

  display: flex;
  align-items: flex-start;
  gap: var(--s-5);
  padding: var(--s-5) var(--s-6);
  border: var(--bw-hair) solid var(--_borde);
  border-radius: var(--r-panel);
  background: var(--_fondo);
  font-family: var(--font-body);
  color: var(--text-body);
}
.alert[data-tone="success"] {
  --_color: var(--status-success);
  --_fondo: var(--status-success-bg);
  --_borde: var(--status-success-border);
}
.alert[data-tone="warning"] {
  --_color: var(--status-warning);
  --_fondo: var(--status-warning-bg);
  --_borde: var(--status-warning-border);
}
.alert[data-tone="danger"] {
  --_color: var(--status-danger);
  --_fondo: var(--status-danger-bg);
  --_borde: var(--status-danger-border);
}
/* Compacto: una línea de 13 semibold del color de texto del tono, icono de 14 al centro, padding 10/14.
   Es el aviso que vive adentro de un formulario (el error o el "te enviamos el enlace" del login). */
.alert[data-compact] {
  --_texto: var(--text-brand);
  align-items: center;
  gap: var(--s-4);
  padding: 10px 14px;
  color: var(--_texto);
}
.alert[data-compact][data-tone="success"] {
  --_texto: var(--text-success);
}
.alert[data-compact][data-tone="warning"] {
  --_texto: var(--text-warning);
}
.alert[data-compact][data-tone="danger"] {
  --_texto: var(--text-danger);
}
.alert[data-compact] .icono {
  margin-top: 0;
  color: var(--_texto);
}
.alert[data-compact] .textos {
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  line-height: var(--lh-normal);
}
.alert[data-compact] .titulo,
.alert[data-compact] .cuerpo {
  display: inline;
  font-size: inherit;
  color: inherit;
}
.icono {
  display: inline-flex;
  margin-top: var(--s-1);
  color: var(--_color);
}
.textos {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-2xs);
  line-height: var(--lh-normal);
}
.titulo {
  font-size: var(--fs-xs);
  font-weight: var(--fw-semibold);
  color: var(--text-strong);
}
.titulo + .cuerpo {
  margin-top: var(--s-1);
}
.cuerpo p {
  margin: 0;
}
.cuerpo p + p {
  margin-top: var(--s-3);
}
.cerrar {
  display: inline-flex;
  padding: var(--s-1);
  border: none;
  border-radius: var(--r-xs);
  background: transparent;
  color: var(--text-subtle);
  cursor: pointer;
}
@media (hover: hover) {
  .cerrar:hover {
    color: var(--text-strong);
    background: var(--action-quiet-active);
  }
}
.cerrar:focus-visible {
  outline: none;
  box-shadow: var(--ring-focus);
}
